<template>
  <v-checkbox
    v-model="checked"
    hide-details
    :indeterminate="indeterminate"
  />
</template>

<script>
import DataTableSelectionStatus from 'Support/enums/DataTableSelectionStatus';

export default {
  name: 'DataTableSelectAllCell',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return ({
      value: false,
      indeterminate: false,
    });
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
        this.$emit('updated-select-all-value', value);
      },
    },
  },
  watch: {
    status: {
      handler(value) {
        if (value === DataTableSelectionStatus.ALL_SELECTED) {
          this.value = true;
          this.indeterminate = false;
        }
        if (value === DataTableSelectionStatus.NONE_SELECTED) {
          this.value = false;
          this.indeterminate = false;
        }

        if (value === DataTableSelectionStatus.ONE_OR_MORE_SELECTED) {
          this.value = false;
          this.indeterminate = true;
        }
      },
    },
  },
};
</script>
